<section>
  <div style="padding: 30px">
    <h3 class="text-center fcolor">TERMS & CONDITIONS</h3>
    <div [innerHTML]="content"></div>
  </div>
  
</section>